<template>
    <div class="about">
        <BasicNavigation header-image="header_tiketing.png"></BasicNavigation>
        <ReservasiKelompok v-if="is_login" :selected-kelompok="selected_kelompok"></ReservasiKelompok>
        <v-container grid-list-md text-xs-center v-if="!is_login">
            <v-layout row align-center justify-center>
                <h1>Reguler</h1>
                <br>
            </v-layout>
            <v-layout row align-center justify-center wrap>
                <v-flex
                    v-for="(item,i) in itemHargaTiket"
                    :key="item.id">
                    <v-card class="rounded-card">
                        <v-card-title primary-title>
                            <v-flex>
                                <h3 class="headline mb-0 text-xs-center">{{ item.nama }}</h3>
                                <br>
                                <div>{{ item.keterangan }}</div>
                                <div>Kuota {{ item.kuota }}</div>
                                <div v-if="item.harga_asal != item.harga">
                                    Promo {{ item.promo.judul }}: <span style="text-decoration: line-through">{{ formatAngka(item.harga_asal) }}</span> {{ formatAngka(item.harga) }}
                                </div>
                            </v-flex>
                        </v-card-title>
                        <div v-if="item.harga_asal != item.harga">
                            <v-btn to="/daftar_reguler">Promo {{ item.promo.judul }}: {{ formatAngka(item.harga) }}/Orang</v-btn>
                        </div>
                        <div v-else>
                            <v-btn to="/daftar_reguler">{{ formatAngka(item.harga) }} /Orang</v-btn>
                        </div>

                    </v-card>
                </v-flex>
            </v-layout>
            <br><br><br>
            <v-layout row align-center justify-center v-if="itemPaketGroup && itemPaketGroup.length">
                <h1>Paket Kelompok</h1>
                <br>
            </v-layout>
            <v-layout row align-center justify-center wrap>
                <v-flex xs12 sm6 md3 lg3 xl3
                    v-for="(item,i) in itemPaketGroup"
                    :key="item.id">
                    <v-card class="rounded-card">
                        <v-card-title primary-title>
                            <div>
                                <h3 class="headline mb-0">{{ item.name }}</h3>
                                <br>
                                <div v-html="item.fasilitas"></div>
                            </div>
                        </v-card-title>
                        <v-btn to="/daftar_paket">{{ formatAngka(item.harga_perorang) }} /Orang</v-btn>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<style scoped>
    .rounded-card{
        border-radius:10px;
    }
</style>

<script>
    import HomeAPI from "@/api/home";
    import KelompokAPI from "@/api/kelompok";
    import BasicNavigation from "@/components/BasicNavigation";
    import ReservasiKelompok from "@/components/reservasi/Kelompok";

    export default {
        components: {
            BasicNavigation,
            ReservasiKelompok,
        },
        data() {
            return {
                itemHargaTiket: [],
                itemPaketGroup: [],
                selected_kelompok: null,
            }
        },
        computed: {
            is_login() {
                return this.$store.getters['auth/check'];
            }
        },
        mounted: function(){
            this.$store.dispatch("loading/start");
            HomeAPI.getHargaTiket().then(response => {
                this.$store.dispatch("loading/stop");
                this.itemHargaTiket = response.data.results.data;
            });

            this.$store.dispatch("loading/start");
            HomeAPI.getPaketGroup().then(response => {
                this.$store.dispatch("loading/stop");
                this.itemPaketGroup = response.data.results.data;
            });

            if(this.is_login) {
                this.$store.dispatch("loading/start");
                KelompokAPI.loadKelompokPrimary().then(response => {
                    this.$store.dispatch("loading/stop");
                    this.selected_kelompok = response.data.results.data;
                });
            }
        },
        methods: {
            formatAngka(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            },
        }
    }
</script>